// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"Skeleton_skeleton__13Q1t","container":"Skeleton_container__2Ch5k","progress":"Skeleton_progress__3AJ9L"};